angular.module('core').filter('acDate', ['dateFilter', function (dateFilter) {
  return function (date) {
    var hoursAgo = (Date.now() - date) / 3600000;
    if (hoursAgo < 12) {
      return dateFilter(date, 'shortTime');
    }
    return dateFilter(date, 'medium');
  };
}]);
